import slug from 'slug';

class QuickLinks {
  constructor(ql) {
    this.ql = ql;
    this.mobileAccordion = document.querySelector('.c-sticky-sidebar__button');
    this.handleClick = this.handleClick.bind(this);
    this.handleOversize = this.handleOversize.bind(this);
    this.observerCallback = this.observerCallback.bind(this);
    this.quickLinks();
  }

  expand() {
    this.mobileAccordion.setAttribute('aria-expanded', true);
    this.ql.classList.add('c-quicklinks--expanded');
  }

  hide() {
    this.mobileAccordion.setAttribute('aria-expanded', false);
    this.ql.classList.remove('c-quicklinks--expanded');
  }

  handleClick() {
    const isExpanded =
      this.mobileAccordion.getAttribute('aria-expanded') === 'true';

    if (isExpanded) {
      this.hide();
    } else {
      this.expand();
    }
  }

  setAsActive(el) {
    const newLinks = document.querySelectorAll('.c-quicklinks__link');
    newLinks.forEach((link) =>
      link.classList.remove('c-quicklinks__link--is-current'),
    );
    el.classList.add('c-quicklinks__link--is-current');
  }

  observerCallback(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const id = slug(entry.target.innerText);
        const activeLink = this.ql.querySelector(`[href="#${id}"]`);
        this.setAsActive(activeLink);
      }
    });
  }

  handleOversize() {
    // Check when mobile is opened if bigger than viewport
    this.ql.style.opacity = 0;
    this.expand();

    const isMobile = window.innerWidth < 768;
    const offset = isMobile ? 90 : 120;
    const container = isMobile
      ? document.querySelector('.c-sticky-sidebar')
      : this.ql;
    const isOversize = window.innerHeight < container.clientHeight + offset;

    document
      .querySelector('.c-sticky-sidebar')
      ?.classList.toggle('c-sticky-sidebar--static', isOversize);

    this.ql.classList.toggle('c-quicklinks--expanded', isMobile && isOversize);
    this.ql.style.opacity = 1;

    if (!isOversize) {
      this.hide();
    }
  }

  createLinks(el) {
    const arrowDown = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.00011 0L7.00011 1.19209e-07L7.00011 7.82831L10.2426 4.58579L11.6568 6L5.99999 11.6569L0.34314 6L1.75735 4.58579L5.00011 7.82854L5.00011 0Z" fill="currentColor"/>
    </svg>`;
    const linkText = el.innerText;
    const linkHref = slug(el.innerText);

    const newLink =
      `<li class='c-quicklinks__item'>` +
      `<a class='c-quicklinks__link border-bot-sweep' href='#${linkHref}' ><i class='c-icon icon-arrow-down-short' aria-hidden='true'>${arrowDown}</i><span class='border-bot-sweep__elem'>${linkText}</span></a>` +
      `</li>`;

    document
      .querySelector('.c-quicklinks')
      .insertAdjacentHTML('beforeend', newLink);
  }

  quickLinks() {
    const links = document.querySelectorAll('[data-pre-title]');

    if (links.length === 0) {
      return;
    }

    [...links].forEach((el) => this.createLinks(el));

    document
      .querySelector('.c-quicklinks')
      .parentElement.querySelector('.u-none')
      .classList.remove('u-none');

    if (this.ql.hasAttribute('data-js-is-sticky')) {
      this.mobileAccordion.addEventListener('click', this.handleClick);

      const observer = new IntersectionObserver(this.observerCallback, {
        root: null,
        rootMargin: '-100px 0px -50%',
        threshold: 0,
      });

      links.forEach((el) => observer.observe(el));

      this.handleOversize();

      window.addEventListener('resize', this.handleOversize);
    }
  }
}

export function init() {
  const ql = document.querySelector('.c-quicklinks');
  if (ql) {
    new QuickLinks(ql);
  }
}
